import { ReportDataContentBody } from '../../types/generated/report_data_post.content';
import { ReportDataResponseBody } from '../../types/generated/report_data_post.response';
import apiEndpoints from '../../../apiEndpoints';
import { fetcher } from '../../utils/fetchers/fetcher';

export const requestReportData = (
  id: string,
  body: ReportDataContentBody,
  token: string | null,
  forceHeader?: string
): Promise<ReportDataResponseBody> =>
  fetcher<ReportDataResponseBody>(
    apiEndpoints.routes.reportData.replace(':reportId', id),
    'POST',
    token,
    forceHeader,
    undefined,
    body
  );
